import PropTypes from 'prop-types';

import { Button, Modal, ModalHeader } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import CalendarIcon from './CalendarIcon';

import './EarlyBookingModal.scss';

const EarlyBookingModal = ({
  isUserLogged,
  isModalOpen,
  onCloseModal,
  onGoToFunnel,
  onOpenLoginModal
}) => {
  const handleFunnelNavigation = () => {
    onCloseModal();

    if (isUserLogged) {
      onGoToFunnel();
    } else {
      onOpenLoginModal();
    }
  };

  const handleChangeDates = () => {
    onCloseModal();
  };

  return (
    <Modal
      className="early-booking-modal"
      isOpen={isModalOpen}
      onRequestClose={onCloseModal}
      contentLabel="early booking modal"
      ariaHideApp={false}
      isRounded={false}
    >
      <ModalHeader onRequestClose={onCloseModal} />

      <div
        className="early-booking-modal__content"
        data-test="early-booking-modal"
      >
        <CalendarIcon />

        <p className="early-booking-modal__title">
          {trans('early-booking-modal.title')}
        </p>
        <p className="early-booking-modal__subtitle">
          {trans('early-booking-modal.subtitle')}
        </p>

        <Button
          color="interaction"
          size="large"
          onClick={handleFunnelNavigation}
          dataTest="earlyBookingModal-navigateFunnel"
          className="early-booking-modal__cta"
        >
          {trans('early-booking-modal.button.continue')}
        </Button>

        <Button
          color="tertiary"
          size="large"
          onClick={handleChangeDates}
          dataTest="earlyBookingModal-changeDates"
          className="early-booking-modal__cta"
        >
          {trans('early-booking-modal.button.changedates')}
        </Button>
      </div>
    </Modal>
  );
};

EarlyBookingModal.propTypes = {
  isUserLogged: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onGoToFunnel: PropTypes.func.isRequired,
  onOpenLoginModal: PropTypes.func.isRequired
};

export default EarlyBookingModal;
